"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringValidator = void 0;
const StringValidatorValidationType_1 = require("../../definitions/utils/validator/stringValidator/StringValidatorValidationType");
class StringValidator {
    static validateString(string, params) {
        switch (params.name) {
            case StringValidatorValidationType_1.StringValidatorValidationType.EMAIL: return this.validateEmail(string);
            case StringValidatorValidationType_1.StringValidatorValidationType.REQUIRED: return this.validateRequired(string);
            case StringValidatorValidationType_1.StringValidatorValidationType.NUMERIC: return this.validateNumeric(string);
            case StringValidatorValidationType_1.StringValidatorValidationType.DOMAIN: return this.validateDomain(string);
            case StringValidatorValidationType_1.StringValidatorValidationType.IPV4: return this.validateIPV4(string);
            case StringValidatorValidationType_1.StringValidatorValidationType.DATE: return this.validateDate(string);
            case StringValidatorValidationType_1.StringValidatorValidationType.DATE_FUTURE: return this.validateDateFuture(string);
            case StringValidatorValidationType_1.StringValidatorValidationType.MAX_LENGTH: return this.validateMaxLength(string, params.meta);
            case StringValidatorValidationType_1.StringValidatorValidationType.MIN_LENGTH: return this.validateMinLength(string, params.meta);
            default: throw Error('Wrong extend validation name: ' + params.name);
        }
    }
    static validateDate(string) {
        const validFormat = /^(0?[1-9]|[12][0-9]|3[01])-(0?[1-9]|1[0-2])-\d\d\d\d$/.test(string);
        if (!validFormat) {
            return false;
        }
        const explodedDMY = string.toString().trim().split('-');
        const inputDate = Date.parse(`${explodedDMY[2]}-${explodedDMY[1]}-${explodedDMY[0]}`);
        return !Number.isNaN(inputDate);
    }
    static validateDateFuture(string) {
        const valid = this.validateDate(string);
        if (!valid) {
            return false;
        }
        const explodedDMY = string.toString().trim().split('-');
        const inputDate = new Date(Date.parse(`${explodedDMY[2]}-${explodedDMY[1]}-${explodedDMY[0]}`));
        const currentDate = new Date();
        inputDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);
        return inputDate.getTime() >= currentDate.getTime();
    }
    static validateMinLength(string, minLength) {
        const strLen = string.toString().trim().length;
        return strLen === 0 || strLen >= minLength;
    }
    static validateMaxLength(string, maxLength) {
        return string.toString().trim().length <= maxLength;
    }
    static validateEmail(string) {
        return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])/.test(string);
    }
    static validateRequired(string) {
        return string.trim().length > 0;
    }
    static validateNumeric(string) {
        if (string.trim().length === 0) {
            return true;
        }
        return /^\d+$/.test(string);
    }
    static validateDomain(string) {
        return /^\b((?=[a-z0-9-]{1,63}\.)(xn--)?[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}\b\.?$/.test(string);
    }
    static validateIPV4(string) {
        if (string.trim().length === 0) {
            return true;
        }
        return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(string);
    }
}
exports.StringValidator = StringValidator;
